// Em algum arquivo onde você mantém seus dados, por exemplo, Tendencias.js
export const tendencias = [
  {
    nome: "Leal e Bom (LB)",
    descricao:
      "Uma criatura típica com essa tendência pode ser contada para fazer o que é correto como é esperado pela sociedade. Dragões dourados, paladinos e muitos anões são leais e bons.",
  },
  {
    nome: "Neutro e Bom (NB)",
    descricao:
      "Pessoas com essa tendência fazem o melhor que podem para ajudar outros de acordo com suas necessidades. Muitos celestiais, alguns gigantes das nuvens e grande parte dos gnomos são neutros e bons.",
  },
  {
    nome: "Caótico e Bom (CB)",
    descricao:
      "Essa tendência é de criaturas que agem de acordo com sua própria consciência, se importando pouco com as expectativas dos outros. Dragões de cobre, muitos elfos e unicórnios são caóticos e bons.",
  },
  {
    nome: "Leal e Neutro (LN)",
    descricao:
      "Indivíduos com essa tendência agem de acordo com as leis, tradições ou códigos pessoais. Muitos monges e alguns magos são leais e neutros.",
  },
  {
    nome: "Neutro (N)",
    descricao:
      "Essa tendência é daqueles que preferem manter distância de questões morais e não tomar partido, fazendo o que aparenta ser melhor conforme a situação. O povo lagarto, muitos druidas e diversos humanos são neutros.",
  },
  {
    nome: "Caótico e Neutro (CN)",
    descricao:
      "Essa tendência é das criaturas que seguem seus caprichos, mantendo sua liberdade pessoal acima de tudo. Muitos bárbaros e ladinos, e alguns bardos, são caóticos e neutros.",
  },
  {
    nome: "Leal e Mau (LM)",
    descricao:
      "Criaturas com essa tendência conseguem metodicamente tudo o que querem, dentro dos limites de uma tradição, lei ou ordem. Diabos, dragões azuis e hobgoblins são leais e maus.",
  },
  {
    nome: "Neutro e Mau (NM)",
    descricao:
      "Essa tendência é daqueles que farão tudo o que quiserem, sem compaixão ou remorso. Muitos drow, alguns gigantes das nuvens e yugoloths são neutros e maus.",
  },
  {
    nome: "Caótico e Mau (CM)",
    descricao:
      "Essa tendência é de criaturas que agem com violência arbitrária, estimulada por sua ganância, ódio ou sede de sangue. Demônios, dragões vermelhos e orcs são caóticos e maus.",
  },
];
